import { render, staticRenderFns } from "./Lend.vue?vue&type=template&id=54840127&scoped=true"
import script from "./Lend.vue?vue&type=script&lang=js"
export * from "./Lend.vue?vue&type=script&lang=js"
import style0 from "./Lend.vue?vue&type=style&index=0&id=54840127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54840127",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
